

//main-product-media-order.js

(function () {
  const observed = new WeakSet();

  function sortByPosition(container) {
    if (!container) return;

    const items = Array.from(
      container.querySelectorAll(
        ':scope > .slider-image, :scope > .slider-video, :scope > .slider-model, :scope > .slider-item'
      )
    );
    if (items.length < 2) return;

    const sorted = items.slice().sort((a, b) => {
      const pa = parseInt(a.getAttribute('data-position') || '9999', 10);
      const pb = parseInt(b.getAttribute('data-position') || '9999', 10);
      return pa - pb;
    });

    for (let i = 0; i < items.length; i++) {
      if (items[i] !== sorted[i]) {
        sorted.forEach((el) => container.appendChild(el));
        break;
      }
    }
  }

  function runForRoot(root) {
    if (!root) return;
    sortByPosition(root.querySelector('.gallery-grid-js'));
    sortByPosition(root.querySelector('.slide-container'));

    // Ensure autoplay for videos on mobile and desktop
    const videos = root.querySelectorAll('video');
    videos.forEach(video => {
      if (video && !video.hasAttribute('autoplay')) {
        video.setAttribute('autoplay', 'true');
      }
    });
  }

  function initRoot(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);

    runForRoot(root);

    let raf = null;
    const obs = new MutationObserver(() => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => runForRoot(root));
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  function initAll() {
    document
      .querySelectorAll('section[id^="MainProduct-"] .feature-product-media')
      .forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  /* ========================================
   * 新增：变体切换时跳转到 featured_media
   * ======================================== */

  /**
   * 获取产品 JSON 数据
   */
  function getProductData() {
    const jsonScript = document.querySelector('[data-product-json]');
    if (jsonScript) {
      try {
        return JSON.parse(jsonScript.textContent);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  /**
   * 根据变体 ID 获取 featured_media 的 position
   */
  function getVariantFeaturedMediaPosition(variantId) {
    const product = getProductData();
    if (!product || !product.variants) return null;

    const variant = product.variants.find(v => v.id === parseInt(variantId, 10));
    if (!variant || !variant.featured_media) return null;

    return variant.featured_media.position;
  }

  /**
   * 跳转到指定位置的媒体（基于 data-position 属性）
   */
  function goToMediaByPosition(position) {
    // 查找主滑块组件
    const slideSection = document.querySelector('.slide-section-media');
    if (!slideSection) return;

    // 查找滑块容器
    const container = slideSection.querySelector('.slide-container');
    if (!container) return;

    // 获取所有媒体项（与原有选择器保持一致）
    const items = Array.from(container.querySelectorAll(
      ':scope > .slider-image, :scope > .slider-video, :scope > .slider-model, :scope > .slider-item'
    ));

    // 查找目标位置的索引（基于排序后的顺序）
    const targetIndex = items.findIndex(item => {
      const itemPosition = parseInt(item.getAttribute('data-position'), 10);
      return itemPosition === position;
    });

    if (targetIndex >= 0) {
      // 尝试使用滑块组件的 goTo 方法
      if (slideSection.slider && typeof slideSection.slider.goTo === 'function') {
        slideSection.slider.goTo(targetIndex);
      } else {
        // 备用方案：触发缩略图点击
        const thumbnailContainer = document.querySelector('.slide-section-thumbnail .slide-container');
        if (thumbnailContainer) {
          const thumbnails = thumbnailContainer.querySelectorAll('.slider-thumbnail');
          if (thumbnails[targetIndex]) {
            thumbnails[targetIndex].click();
          }
        }
      }
    }
  }

  /**
   * 初始化变体切换监听
   */
  function initVariantChangeListener() {
    let lastVariantId = new URLSearchParams(window.location.search).get('variant');
    let isInitialLoad = true;

    function handleVariantChange() {
      const currentVariantId = new URLSearchParams(window.location.search).get('variant');
      
      // 首次加载时不跳转（保持显示第一个媒体/视频）
      if (isInitialLoad) {
        isInitialLoad = false;
        lastVariantId = currentVariantId;
        return;
      }

      // 变体未变化时不处理
      if (!currentVariantId || currentVariantId === lastVariantId) return;
      lastVariantId = currentVariantId;

      // 获取变体的 featured_media position 并跳转
      const position = getVariantFeaturedMediaPosition(currentVariantId);
      if (position !== null) {
        // 延迟执行，确保 DOM 已更新
        setTimeout(() => goToMediaByPosition(position), 100);
      }
    }

    // 监听 URL 变化
    let checkInterval = setInterval(() => {
      const currentVariantId = new URLSearchParams(window.location.search).get('variant');
      if (currentVariantId !== lastVariantId) {
        handleVariantChange();
      }
    }, 250);

    // 监听变体选择器的 change 事件
    document.addEventListener('change', (e) => {
      if (e.target.closest('variant-selects, variant-radios')) {
        setTimeout(handleVariantChange, 200);
      }
    });
  }

  // 页面加载完成后初始化变体切换监听
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantChangeListener);
  } else {
    initVariantChangeListener();
  }
})();
